import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useFormatPreview } from '@/composables/format-edit/useFormatPreview'
import { formatPreviewCreateDate } from '@/utils/format-edit/previewDates'
import { useHostServices } from '@/composables/format-edit/useHostServices'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoCareerPreview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean };



const { formLib } = useHostServices()
const { scaleStyle, highlightMessage, goCardTo, highLightClass } =
  useFormatPreview(props)

const formatedCreateDate = computed(() =>
  formatPreviewCreateDate(
    props.formatData?.createDate,
    formLib.dateFormat,
    'placeholder'
  )
)

function checkValid() {}

expose({ checkValid })

return { __sfc: true,props, formLib, scaleStyle, highlightMessage, goCardTo, highLightClass, formatedCreateDate, checkValid }
}

})